import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum RequisitoSenha {
  MinimoCaracteres = 1,
  RequerLetraMaiuscula = 2,
  RequerLetraMinuscula = 3,
  RequerCaracterEspecial = 4,
  RequerNumero = 5,
}

export const MINIMO_CARACTERES_SENHA = 8;

export class RequisitoSenhaEnum extends GenericoTipoEnum<RequisitoSenha> {
  static readonly MinimoCaracteres  = new RequisitoSenhaEnum(RequisitoSenha.MinimoCaracteres , `Mínimo de ${MINIMO_CARACTERES_SENHA} caracteres`);
  static readonly RequerLetraMaiuscula = new RequisitoSenhaEnum(RequisitoSenha.RequerLetraMaiuscula, 'Ao menos uma letra maiúscula');
  static readonly RequerLetraMinuscula = new RequisitoSenhaEnum(RequisitoSenha.RequerLetraMinuscula, 'Ao menos uma letra minúscula');
  static readonly RequerNumero = new RequisitoSenhaEnum(RequisitoSenha.RequerNumero, 'Ao menos um número');
  static readonly RequerCaracterEspecial = new RequisitoSenhaEnum(RequisitoSenha.RequerCaracterEspecial, 'Ao menos um caractere especial');
}
